class RoleConstants {
  static StrategicRiskManager = "Strategic_Risk_Manager";
  static StrategicRiskVisitor = "Strategic_Risk_Visitor";
  static StrategicRiskClusterOwner = "Strategic_Risk_Cluster_Owner";
  static StrategicRiskCategoryManager = "Strategic_Risk_Category_Manager";
}
export default RoleConstants;
